<template>
    <div>
        <div id="print" class="d-flex flex-wrap">
            <div id="printObj">
                <div v-for="item in items" v-bind:key="item.id" class="printPage">
                    <div class="headerDiv">
                        <label class="sithLabel">SITH</label>
                        <img class="logoImg" src="@/assets/images/logo_siemens_energy.png"/>
                    </div>
                    <div class="simpleInfoDiv">
                        <label class="contentLabel">项目号/Project No.</label><br/>
                        <label class="contentLabel">发货码/Del.Code.</label><br/>
                    </div>
                    <div class="simpleValueDiv">
                        <div class="simpleInputDiv">
                            <input class="simpleInput" type="text" v-model="item.projectCode"/>
                        </div>
                        <div class="simpleInputDiv">
                            <input class="simpleInput" type="text" v-model="item.deliverCode"/>
                        </div>
                    </div>
                    <div class="detailLabel">
                        <label class="textareaLabel">物料描述/Description.</label><br/>
                        <label class="contentLabel1">物料号/Material No.</label><br/>
                        <label class="contentLabel1">数量/Quantity.</label><br/>
                        <label class="contentLabel1">PO/Item No.</label><br/>
                        <label class="contentLabel1">PPO/Item No.</label><br/>
                        <label class="contentLabel1">重量(毛重/净重)/Weight.</label><br/>
                    </div>
                    <div class="detailDiv">
                        <div class="textareaDiv">
                            <textarea rows="3" :value="item.description"
                                      @input="item.description = $event.target.value"></textarea>
                        </div>
                        <div class="detailInputDiv materialCodeDiv">
                            <textarea class="detailInput" type="text" :value="autoChangeLine(item,'materielCode')"/>
                        </div>
                        <div class="detailInputDiv">
                            <input class="detailInput" type="text"
                                   :value="getValue(item,'purchaseQuantity','materielUnit')"/>
                        </div>
                        <div class="detailInputDiv">
                            <input class="detailInput" type="text" :value="getValue(item,'logPoId','poItem')"/>
                        </div>
                        <div class="detailInputDiv">
                            <input class="detailInput" type="text"
                                   :value="getValue(item,'productionNumber','productionItem')"/>
                        </div>
                        <div class="detailInputDiv">
                            <input class="detailInput" type="text" :value="getWeightValue(item)"/>
                        </div>
                        <div class="qrCode">
                            <img :src="item.src" alt="图片找不到了。。。。"/><br/>
                        </div>
                    </div>
                </div>
            </div>
            <br/>
            <el-button v-print="'#printObj'" class="print-btn ml-1" v-if="!isMobileDevice">桌面端打印标签</el-button>
            <el-button type="primary" class="print-btn ml-1" v-if="isMobileDevice" @click="openApp('?'+'json='+encodeURIComponent(JSON.stringify(items,function (key,value) {
                if(key =='src') {
                    return undefined;
                }
                return value;
            }))+'&printType=itemPrint')"
            >移动端蓝牙打印标签
            </el-button>
            <el-button type="primary" class="print-btn ml-2" v-if="isMobileDevice" @click="downloadApp()">
                下载移动端最新app
            </el-button>
        </div>
    </div>

</template>

<script>

import emCommonListMixin from "@/mixin/em/common/list";
import emCommonApiMixin from "@/mixin/em/common/api";

let timer;
export default {
    name: "PrintView",
    data: function () {
        return {
            type: 'pc',
            ua: window.navigator.userAgent.toLowerCase(),
            androidSchemeUrl: 'siemens://sithmom:9999/print',
            iosSchemeUrl: '',
            androidDownloadUrl: 'https://pan.baidu.com/s/1lvSudBwWCYpjTME1GlmBLA?pwd=5r18',
            iosDownloadUrl: '',
            picture: '',
            items: [],
        };
    },
    components: {},
    mixins: [emCommonListMixin, emCommonApiMixin],
    computed: {
        isMobileDevice() {
            return /iphone|ipad|ipod/.test(this.ua) || /android/.test(this.ua);
        },
    },
    methods: {
        getPicture(item) {
            let that = this;
            let _url = `${this.$_emApiMixin_entityBaseApi("sithMesInventoryItem")}/getQrPicture`;
            this.$_emApiMixin_post(_url, item).then((data) => {
                that.$set(item, 'src', data.data);
                that.$set(item, 'description', that.convertUndefined(item.descriptionCh) + '/' + that.convertUndefined(item.descriptionEn));
            });
        },
        watchVisibility() {
            window.addEventListener('visibilitychange', () => {
                // 监听页面visibility
                if (document.hidden && timer != null) {
                    // 如果页面隐藏了，则表示唤起成功，这时候需要清除下载定时器
                    clearTimeout(timer)
                }
            })
        },
        convertUndefined(property) {
            if (property === undefined) return '';
            return property;
        },
        getValue(item, property, poItem) {
            if (item[property] && item[poItem]) {
                return item[property] + '/' + item[poItem];
            }
            if (item[property]) {
                return item[property];
            }
            if (item[poItem]) {
                return item[poItem];
            }
            return '';
        },
        // FY26需求：物料标签重量行，取物料主数据 毛重/净重 + 重量单位，如 "12.5/10.2 KG"
        // 注意：重量为数值字段（0 也应如实显示，与物料主数据同步），故单独走数值判断，
        // 不复用 getValue（getValue 对 falsy 的 0 会被吞掉，适用于字符串字段）。
        getWeightValue(item) {
            let gross = item.grossWeight;
            let net = item.netWeight;
            let grossStr = gross !== null && gross !== undefined && gross !== '' ? String(gross) : '';
            let netStr = net !== null && net !== undefined && net !== '' ? String(net) : '';
            let weight = '';
            if (grossStr && netStr) {
                weight = grossStr + '/' + netStr;
            } else if (grossStr) {
                weight = grossStr;
            } else if (netStr) {
                weight = netStr;
            }
            if (weight && item.weightUnit) {
                return weight + ' ' + item.weightUnit;
            }
            return weight;
        },
        //判断是否为微信浏览器
        isWeiXin() {
            return this.ua.match(/MicroMessenger/i) == "micromessenger" || this.ua.match(/_SQ_/i) == "_sq_";
        },
        //打开app
        openApp(data) {
            if (/iphone|ipad|ipod/.test(this.ua)) {
                this.type = "ios";

            } else if (/android/.test(this.ua)) {
                this.type = "android";
            }
            if (!this.isWeiXin()) {
                switch (this.type) {
                    case "pc": {
                        break;
                    }
                    case "android": {
                        location.href = this.androidSchemeUrl + data;
                        let androidDownloadUrl = this.androidDownloadUrl;
                        timer = setTimeout(function () {
                            window.location.href = androidDownloadUrl;
                        }, 5000);
                        break;
                    }
                    case 'ios': {
                        location.href = this.iosSchemeUrl + data;
                        let iosDownloadUrl = this.iosDownloadUrl;
                        timer = setTimeout(function () {
                            window.location.href = iosDownloadUrl;
                        }, 5000);
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        },
        downloadApp() {
            window.location.href = this.androidDownloadUrl;
        },
        autoChangeLine(item, property) {
            if (property === 'materielCode') {
                if (item[property]) {
                    if (item[property].includes('-')) {
                        return item[property].replace('-', '\n')
                    } else {
                        return item[property];
                    }
                } else {
                    return '';
                }
            }
            return item[property];
        },
    },
    mounted() {
        this.items = this.$route.query;
        this.items.forEach((item) => {
            this.getPicture(item);
        })
        this.watchVisibility();
    }
}
</script>

<style scoped>

@page {
    size: 120mm 90mm !important;
}

@media print {
    .printPage {
        page-break-after: always;
        margin: 4px !important;
    }

    .printPage:last-child {
        page-break-after: auto;
    }

    input {
        border: none;
    }

    textarea {
        border: none;
    }

    #printObj {
        height: auto;
        width: 580px;
        margin: 2px !important;
    }

    .print-btn {
        visibility: hidden;
    }


}

.printPage {
    height: 370px;
    width: 580px;
}

#printObj {
    height: auto;
    width: 580px;
    margin: 80px;
}

.simpleInput {
    height: 25px;
    width: 100%;
    font-size: 19px;
    line-height: 35px;
    margin-left: 2px;
}

.detailInput {
    height: 30px;
    width: 96%;
    font-size: 16px;
    line-height: 30px;
    margin-left: 2px;
}

.contentLabel1 {
    font-size: 17px;
    height: 32px;
    display: inline-block;
    line-height: 32px;
    width: 100%;
    text-align: left;
}

.contentLabel {
    font-size: 19px;
    height: 35px;
    display: inline-block;
    line-height: 35px;
    width: 100%;
    text-align: left;
}

.qrCode {
    width: 140px;
    height: 140px;
    margin-top: -113px;
    float: left;
}

.qrCode img {
    width: 165px;
    height: 165px;
    margin-top: -22px;
}

.logoImg {
    margin-left: 340px;
    width: 85px;
    height: 38px;
}

.sithLabel {
    float: left;
    font-size: 20px;
}

.headerDiv {
    width: 100%;
    height: 40px;
}

.simpleInfoDiv {
    border-style: solid solid solid none;
    width: 200px !important;
    height: 70px;
    float: left;
    border-width: thin;
}

.simpleValueDiv {
    border-style: solid none solid none;
    border-width: thin;
    width: 370px;
    height: 70px;
    float: left;
}

.simpleInputDiv {
    width: 100%;
    height: 35px;
    float: left;
    line-height: 35px;
}

.detailLabel {
    border-style: solid solid solid none;
    border-width: thin;
    width: 200px;
    height: 230px;
    float: left;
    margin-top: 15px;
    text-align: left;
}

.textareaLabel {
    height: 60px;
    line-height: 60px;
    font-size: 19px;
    width: 100%;
    text-align: left;
}

.detailDiv {
    border-style: solid none solid none;
    border-width: thin;
    width: 370px;
    height: 230px;
    float: left;
    margin-top: 15px;
}

.textareaDiv {
    width: 100%;
    height: 60px;
    float: left;
    line-height: 60px;
}

textarea {
    word-break: break-all;
    width: 359px;
    height: 55px;
    font-size: 16px !important;
    margin-left: 2px !important;
    margin-top: 2px !important;
    line-height: 16px !important;
}

.detailInputDiv {
    width: 200px;
    height: 32px;
    float: left;
    line-height: 32px;
}

/* FY26需求：物料号行增高容纳拆包后缀换行（如 E1A4976764-43/44 → 两行），用掉 detailDiv 仅剩余量，底边框不动 */
.materialCodeDiv {
    height: 40px;
    line-height: 21px;
}

.materialCodeDiv .detailInput {
    height: 42px;
    line-height: 21px;
}

label {
    margin-bottom: 0 !important;
}

.print-btn {
    height: min-content;
    margin-top: 80px !important;
}

</style>
